import { render, staticRenderFns } from "./RankingsDetailTable.vue?vue&type=template&id=39be63f4&scoped=true"
import script from "./RankingsDetailTable.vue?vue&type=script&lang=js"
export * from "./RankingsDetailTable.vue?vue&type=script&lang=js"
import style0 from "./RankingsDetailTable.vue?vue&type=style&index=0&id=39be63f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be63f4",
  null
  
)

export default component.exports